import { z } from "zod";

// Day Enum - matching backend Day
export enum EDay {
    SUNDAY = "SUNDAY",
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
  }

export const dateOfBirthSchema = z.object({
  year: z.number(),
  month: z.number(),
  date: z.number(),
});

export type IDateOfBirth = z.infer<typeof dateOfBirthSchema>;

export const updateDateOfBirthSchema = z.object({
  year: z.number(),
  month: z.number(),
  day: z.number(),
});

export type IUpdateDateOfBirth = z.infer<typeof updateDateOfBirthSchema>;